import { TAB_LABELS } from '../constants';

const getProperty = (foundTitle, properties) => {
  const foundProperty = properties.find(prop => foundTitle && foundTitle[prop]);
  return foundProperty ? foundTitle[foundProperty] : '';
};

export const getTitle = foundTitle => {
  return getProperty(foundTitle, ['name', 'symbol', 'strID', 'chemPrefName']);
};

export const getName = foundTitle => {
  return getProperty(foundTitle, ['diseaseUMLSCUI', 'description', 'geneSymbol', 'id']);
};

export const getId = foundTitle => {
  return getProperty(foundTitle, ['id', 'geneID', 'strID', 'id']);
};

export const getTabList = (view: string, tab: string) => {
  if (view === 'ALL') {
    return TAB_LABELS.filter(t =>
      ['GDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS', 'CHEMICALS'].includes(t.key),
    );
  } else if (view === 'GENES' && ['GDA', 'VDA'].includes(tab as string)) {
    return TAB_LABELS.filter(t => ['GDA', 'VDA'].includes(t.key));
  } else if (view === 'DISEASES' && ['GDA', 'VDA', 'DDA'].includes(tab as string)) {
    return TAB_LABELS.filter(t => ['GDA', 'VDA', 'DDA'].includes(t.key));
  } else if (view === 'VARIANTS' && ['VDA'].includes(tab as string)) {
    return TAB_LABELS.filter(t => ['VDA'].includes(t.key));
  } else if (view === 'CHEMICALS' && ['GDA', 'VDA'].includes(tab as string)) {
    return TAB_LABELS.filter(t => ['GDA', 'VDA'].includes(t.key));
  } else {
    console.error('Invalid tab selection');
    return [];
  }
};

const metricsRedirectNames = ['geneDSI', 'geneDPI', 'variantDSI', 'variantDPI', 'DSI', 'DPI', 'EI', 'score'];

const sourcesRedirectNames = ['jaccard_genes', 'jaccard_variants'];

const associationTypeRedirectNames = ['associationType'];

const attributesRedirectNames = [
  'geneProteinStrIDs',
  'proteinIDs',
  'EL',
  'firstRef',
  'yearInitial',
  'lastRef',
  'yearFinal',
  'pmid',
  'source',
  'DBSNPclass',
  'alleleFreqGenome',
  'genome',
  'alleleFreqExome',
  'exome',
  'coord',
  'alleles',
  'chromosome',
  'mostSevereConsequences',
  'type',
  'diseaseType',
  'diseaseClassName_MSH',
  'diseaseClassName_UMLS',
  'diseaseClassName_HPO',
  'diseaseClassName_DO',
  'pvalue_jaccard_genes',
  'pvalue_jaccard_variants',
  'sokal',
  'geneProteinClassNames',
  'proteinClassIDs',
  'genepLI',
  'PLI',
  'riskAllele',
  'or_or_beta',
  'pValue',
];

const totalRedirectNames = metricsRedirectNames.concat(
  sourcesRedirectNames,
  associationTypeRedirectNames,
  attributesRedirectNames,
);

export {
  metricsRedirectNames,
  sourcesRedirectNames,
  associationTypeRedirectNames,
  attributesRedirectNames,
  totalRedirectNames,
};

const listSourceAcademic = {
  CURATED: ['CURATED'],
};

// sources GDA and DDA
const listSourceGDAs_DDAs = {
  CURATED: ['CURATED', 'CLINGEN', 'CLINVAR', 'MGD_HUMAN', 'ORPHANET', 'PSYGENET', 'RGD_HUMAN', 'UNIPROT'],
  CLINICALTRIALS: ['CLINICALTRIALS'],
  INFERRED: ['INFERRED', 'HPO', 'FINNGEN', 'GWASCAT', 'PHEWASCAT', 'UKBIOBANK'],
  MODELS: ['MODELS', 'MGD_MOUSE', 'TEXTMINING_MODELS', 'RGD_RAT'],
  TEXTMINING: ['TEXTMINING_HUMAN'],
  ALL: ['ALL'],
};

// sources Variant and VDAs
const listSourceVariantAll_VDAs = {
  CURATED: ['CURATED', 'CLINVAR', 'GWASCAT', 'PHEWASCAT', 'UNIPROT'],
  TEXTMINING_HUMAN: ['TEXTMINING_HUMAN'],
  BIOBANK: ['BIOBANK', 'FINNGEN', 'UKBIOBANK'],
  ALL: ['ALL'],
};

// sources Disease
const listSourceDiseaseAll = {
  CURATED: ['CURATED', 'CLINGEN', 'CLINVAR', 'MGD_HUMAN', 'ORPHANET', 'PSYGENET', 'RGD_HUMAN', 'UNIPROT'],
  CLINICALTRIALS: ['CLINICALTRIALS'],
  BIOBANK: ['BIOBANK', 'FINNGEN', 'UKBIOBANK'],
  INFERRED: ['INFERRED', 'FINNGEN', 'GWASCAT', 'HPO', 'INFERRED', 'PHEWASCAT', 'UKBIOBANK'],
  MODELS: ['MODELS', 'MGD_MOUSE', 'TEXTMINING_MODELS', 'RGD_RAT'],
  TEXTMINING: ['TEXTMINING_HUMAN'],
  ALL: ['ALL'],
};
// sources Gene
const listSourceGeneALL = {
  CURATED: ['CURATED', 'CLINGEN', 'CLINVAR', 'MGD_HUMAN', 'ORPHANET', 'PSYGENET', 'RGD_HUMAN', 'UNIPROT'],
  CLINICALTRIALS: ['CLINICALTRIALS'],
  INFERRED: ['INFERRED', 'FINNGEN', 'GWASCAT', 'HPO', 'PHEWASCAT', 'UKBIOBANK'],
  MODELS: ['MODELS', 'MGD_MOUSE', 'TEXTMINING_MODELS', 'RGD_RAT'],
  TEXTMINING: ['TEXTMINING_HUMAN'],
  ALL: ['ALL'],
};

export {
  listSourceGDAs_DDAs,
  listSourceVariantAll_VDAs,
  listSourceAcademic,
  listSourceDiseaseAll,
  listSourceGeneALL,
};


